import { Button } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

import CheckMark from '../assets/svg/disc/check-disc.svg';
import { min } from '../utils/breakpoints';

const StyledImg = styled.img`
  width: 50px;

  ${min.sm} {
    width: 80px;
  }
`;

interface InverterConnectedMessageProps {
  onContinue: () => void;
}

/** Shared "connected" success message for both the onboarding flow and the settings reconnect modal. */
const InverterConnectedMessage = ({ onContinue }: InverterConnectedMessageProps) => {
  const theme = useTheme();

  return (
    <>
      <h1 className="mb-3" id="inverter-connection-heading">
        Connected to your system
      </h1>
      <div className="mt-1 mb-4">
        <StyledImg src={CheckMark} alt="Success checkmark" />
      </div>
      <p className="mb-0">{theme.language.appName} has successfully connected to your inverter.</p>
      <Button className="mb-2" onClick={onContinue}>
        Continue
      </Button>
    </>
  );
};

export default InverterConnectedMessage;
